//https://console.firebase.google.com/u/0/project/question-salad/firestore/databases/-default-/data

import { IQuestion } from "../types";
import { initializeApp } from "firebase/app";
import { useCallback, useEffect, useState } from "react";
import {
    getFirestore,
    collection,
    query,
    where,
    limit,
    getDocs,
    Query,
    WhereFilterOp,
    updateDoc,
    doc,
    increment,
    startAfter,
    orderBy,
    getDoc,
} from "firebase/firestore";
import { Helpers } from "../helpers/helpers";
import { getAnalytics, logEvent } from "firebase/analytics";


// import { setLogLevel } from "firebase/firestore";
// setLogLevel("debug");

const firebaseConfig = {

    apiKey: "AIzaSyAPKl_DLoA6EGkYbTMKvTdoktEGTVNe2Yc",

    authDomain: "question-salad.firebaseapp.com",

    projectId: "question-salad",

    storageBucket: "question-salad.firebasestorage.app",

    messagingSenderId: "506073112941",

    appId: "1:506073112941:web:9a6078bb8a923a6b2f3a64",

    measurementId: "G-ETWLPCZZE3"

};


const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);

export interface IFilter {
    field: "num_marks" | "board" | "difficulty" | "year";
    op: WhereFilterOp;
    value: any;
}

interface FirestoreQueryOptions {
    topic: string, subTopic: string, subSubTopic: string,
    filters: IFilter[];
    collectionName: string;
    cursor: IQuestion | null;
}

export async function markFaulty(collection: string, id: string) {
    try {
        const docRef = doc(db, collection, id);

        await updateDoc(docRef, {
            fault_clicks: increment(1),
        });
    }
    catch (error) {
        console.error("Error updating document: ", error);
    }
}

function random_year(y: number) {
    return y + Helpers.chooseRandom([-2, -1, 1, 2])
}

function replace_zero_with_one(y: number) {
    return y == 0 ? 1 : y;
}

function isDevelopment() {
    return window.location.href.indexOf("localhost") != -1;
}

const PAGE_SIZE = 10
export function useFirestoreQuery(options: FirestoreQueryOptions) {
    const {
        topic, subTopic, subSubTopic,
        filters,
        collectionName,
        cursor
    } = options;

    const [data, setData] = useState<IQuestion[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        // console.log(filters);

        let orderByField = ["num_marks", "difficulty", "year"].indexOf(filters[0]?.field) != -1 ?
            filters[0]?.field :
            false;
        // console.log(`orderByField: ${orderByField}`);

        async function fetchData() {
            setLoading(true);
            setError(null);

            // console.log("querying...");
            // console.log(cursor);

            try {
                let q: Query = collection(db, collectionName);

                if (subSubTopic != "Subsubtopic") {
                    q = query(q, where("sub_sub_topic", "==", subSubTopic));
                }
                else if (subTopic != "Subtopic") {
                    q = query(q, where("sub_topic", "==", subTopic));
                }
                else if (topic != "Topic") {
                    q = query(q, where("topic", "==", topic));
                }

                if (filters.length) {
                    for (let f of filters) {
                        q = query(q, where(f.field, f.op, f.value));
                    }
                }

                if (orderByField) {
                    q = query(q, orderBy(orderByField as string));
                }
                q = query(q, orderBy('__name__'));

                if (cursor) {
                    switch (orderByField) {
                        case "difficulty":
                            q = query(q, startAfter(cursor.difficulty, cursor.id))
                            break;
                        case "num_marks":
                            q = query(q, startAfter(cursor.num_marks, cursor.id))
                            break;
                        case "year":
                            q = query(q, startAfter(cursor.year, cursor.id))
                            break;
                        case "board":
                        case false:
                            q = query(q, startAfter(cursor.id))
                            break;
                    }
                }

                q = query(q, limit(PAGE_SIZE));

                const snapshot = await getDocs(q);

                const items = snapshot.docs.map((doc) => {
                    let data = doc.data();
                    return ({
                        id: doc.id,
                        collection: collectionName,
                        ...data,
                        year: random_year(data["year"]),
                        num_marks: replace_zero_with_one(data["num_marks"]),
                    })
                }
                ) as IQuestion[];

                if (cursor) {
                    setData([...data, ...items]);
                }
                else {
                    setData(items);
                }

            } catch (err: any) {
                console.error("Firestore query error:", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, [JSON.stringify(filters), collectionName, cursor, topic, subTopic, subSubTopic]);

    return { data, loading, error };
}



export function useItem(collectionName: string, id: string): IQuestion | null {
    const [item, setItem] = useState<IQuestion | null>(null);
    useEffect(() => {
        if (id == "" || collectionName == "") return;
        const docRef = doc(db, collectionName, id);
        getDoc(docRef)
            .then(snapshot => {
                if (snapshot.exists()) {
                    let data = snapshot.data();
                    setItem({
                        ...data,
                        id: snapshot.id,
                        collection: collectionName,
                        year: random_year(data["year"]),
                        num_marks: replace_zero_with_one(data["num_marks"]),
                    } as IQuestion)
                }
            })
    }, [id, collection]);
    return item;
}

export function useAnalytics() {
    /**
     * Track an event in Firebase Analytics
     * @param {string} eventName - name of the event (e.g. "purchase")
     * @param {object} params - event parameters (optional)
     */
    const track = useCallback((eventName: AnalyticsEvent, params: any = {}) => {
        if (!analytics) {
            console.warn("Analytics not initialized");
            return;
        }

        try {
            if (isDevelopment()) {
                console.log(`[Analytics] ${eventName as string}`, params);
            }
            else {
                logEvent(analytics, eventName as string, params);
            }
        }
        catch (err) {
            console.error("Analytics error:", err);
        }
    }, []);

    return { track };
}

export type AnalyticsEvent = "favourites.add" | "favourites.remove" | "favourites.clear" | "favourites.show" | "favourites.hide" | "favourites.rename" |
    "filters.update" |
    "item.info" | "item.scribble" | "item.favourite.add" | "item.favourite.remove" | "item.fault.add" |
    "downloadPdf" | "share" | "location.update" | "scroll" | "selectAll" | "deselectAll" |
    "settings.questionHeight.update" | "settings.magnification.update" | "settings.showFaulty.update" | "settings.columns.update" | "settings.pdfDownload.update";